import Image1 from '../props/html.png';
import Image2 from '../props/css.png';
import Image3 from '../props/js.png';

import Image4 from '../props/tailwind.png';

import Image5 from '../props/react.png';
import Image6 from '../props/node.png';
import Image7 from '../props/express.png';

import { Link } from 'react-router-dom';

import Image8 from '../props/aws.png';
import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import { CursorContext } from '../context/CursorContext';

const Skills = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: window.innerWidth }}
      transition={transition1}
      className="section hero"
    >
      <div className="container mx-auto h-full relative">
        <div className="flex flex-col lg:flex-row h-full items-center justify-start gap-x-24 text-center lg:text-left  pt-18  lg:pt-36 pb-4">
          <div
            className="pt-28 pb-1 lg:pt-0 lg:w-auto z-8 flex flex-col justify-center items-center px-10 lg:items-start text-primary text-center"
            onMouseEnter={mouseEnterHandler}
            onMouseLeave={mouseLeaveHandler}
          >
            <h1 className="h1 ">My Skills</h1>
            <p className=" mb-4 max-w-lg text-lg lg:text-xl text-justify ">
              As a Aspiring full-stack developer, proficient in front-end
              technologies like HTML, CSS, and JavaScript, and capable of
              building back-end applications using Node.js and Express.js. Keen
              on continuous learning and problem-solving skills.
            </p>
            <Link to={'/portfolio'} className="btn ">
              View My Projects
            </Link>
          </div>

          <div className="grid grid-cols-4 lg:gap-1 rounded-2xl">
            <div className="max-w-[200px] lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover  lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image1}
                alt=""
              />
            </div>
            <div className="max-w-[200px]  lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover  lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image2}
                alt=""
              />
            </div>
            <div className="max-w-[200px] lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover  lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image3}
                alt=""
              />
            </div>
            <div className="max-w-[200px]  lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image4}
                alt=""
              />
            </div>
            <div className="max-w-[200px]  lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image5}
                alt=""
              />
            </div>
            <div className="max-w-[200px]  lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image6}
                alt=""
              />
            </div>
            <div className="max-w-[200px] lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image7}
                alt=""
              />
            </div>
            <div className="max-w-[200px]  lg:max-w-[320px] h-[160px] lg:h-[220px]  overflow-hidden">
              <img
                className="object-cover  lg:h-[140px] hover:scale-110  transition-all duration-500"
                src={Image8}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Skills;
